module.exports = __webpack_public_path__ + "static/media/icon-x.f7fa383c.svg";